/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CommonEmptyRequest } from '../models/CommonEmptyRequest';
import type { EvmAddressTokenHoldingListInfo } from '../models/EvmAddressTokenHoldingListInfo';
import type { EvmAddressTokenHoldingListRequest } from '../models/EvmAddressTokenHoldingListRequest';
import type { EvmNftLatestMintRequest } from '../models/EvmNftLatestMintRequest';
import type { EvmNftMetadataRefreshInfo } from '../models/EvmNftMetadataRefreshInfo';
import type { EvmNftMetadataRefreshRequest } from '../models/EvmNftMetadataRefreshRequest';
import type { NexonNativeTokenInfo } from '../models/NexonNativeTokenInfo';
import type { NexonNftMintDetailInfo } from '../models/NexonNftMintDetailInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class NexonService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getNativeToken({
        requestBody,
    }: {
        requestBody: CommonEmptyRequest,
    }): CancelablePromise<NexonNativeTokenInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/token/native',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getLatestMint({
        requestBody,
    }: {
        requestBody: EvmNftLatestMintRequest,
    }): CancelablePromise<NexonNftMintDetailInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/nft/mint/latest',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public refreshNftMetadata({
        requestBody,
    }: {
        requestBody: EvmNftMetadataRefreshRequest,
    }): CancelablePromise<EvmNftMetadataRefreshInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/nft/metadata/refresh',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getNftHoldingList({
        requestBody,
    }: {
        requestBody: EvmAddressTokenHoldingListRequest,
    }): CancelablePromise<EvmAddressTokenHoldingListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/token/nft/holding/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getErc721HoldingList({
        requestBody,
    }: {
        requestBody: EvmAddressTokenHoldingListRequest,
    }): CancelablePromise<EvmAddressTokenHoldingListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/token/erc721/holding/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getErc20HoldingList({
        requestBody,
    }: {
        requestBody: EvmAddressTokenHoldingListRequest,
    }): CancelablePromise<EvmAddressTokenHoldingListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/token/erc20/holding/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getErc1155HoldingList({
        requestBody,
    }: {
        requestBody: EvmAddressTokenHoldingListRequest,
    }): CancelablePromise<EvmAddressTokenHoldingListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/address/token/erc1155/holding/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
